<div class="flex flex-col">
  <ng-container *ngFor="let feedItem of feedItems$ | async; trackBy: 'title' | trackByKey">
    <div class="flex items-center">
      <div class="flex-1 text-gray-700">
        {{ feedItem.title }}
      </div>
      <div style="width: 100px" class="text-sm text-gray-600">
        {{ feedItem.date | standardDate }}
      </div>
    </div>
    <div class="w-full text-sm text-gray-600">
      {{ feedItem.category }}
    </div>
  </ng-container>
</div>
